<template>
  <router-link class="album-card" :to="'/gallery/' + galleryid + '/0'">
    <div class="album-card__media" v-lazyload>
      <div class="skeleton skeleton-loading album-card__skeleton" :data-url="thumbnail"></div>
      <img class="album-card__image image__item" :data-url="thumbnail" :alt="title" />
      <div class="album-card__shade"></div>
    </div>
    <div class="album-card__body">
      <p class="album-card__date" v-if="created_at">{{ fancyDate }}</p>
      <h2 class="album-card__title">{{ title }}</h2>
      <span class="album-card__cta">Ansehen</span>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "GalleryCard",
  props: {
    galleryid: [String, Number],
    title: String,
    description: String,
    thumbnail: String,
    images: Array,
    created_at: String,
  },
  computed: {
    fancyDate() {
      if (!this.created_at || this.created_at.length < 10) {
        return "";
      }
      var year = this.created_at.slice(0, 4);
      var month = this.created_at.slice(5, 7);
      var day = this.created_at.slice(8, 10);
      return day + "." + month + "." + year;
    },
  },
};
</script>

<style scoped>
.album-card {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  overflow: hidden;
  background: #121013;
  color: #f4f1ed;
  cursor: pointer;
  isolation: isolate;
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.4);
}

.album-card:hover,
.album-card:focus-within {
  transform: translateY(-4px);
  border-color: rgba(204, 44, 206, 0.55);
  box-shadow: 0 22px 48px rgba(204, 44, 206, 0.22);
}

.album-card__media {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: #18141c;
}

.album-card__image,
.album-card__skeleton {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.45s ease;
}

.album-card:hover .album-card__image {
  transform: scale(1.05);
}

.album-card__shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(8, 8, 10, 0.05) 18%,
    rgba(8, 8, 10, 0.82) 100%
  );
  pointer-events: none;
}

.album-card__body {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  padding: 1.25rem 1.25rem 1.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.album-card__date {
  margin: 0;
  font-family: 'Manrope', sans-serif;
  font-size: 0.75rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #dcff21;
}

.album-card__title {
  margin: 0;
  font-family: 'Archivo', sans-serif;
  font-size: 1.25rem;
  line-height: 1.2;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.01em;
}

.album-card__cta {
  margin-top: 0.65rem;
  align-self: flex-start;
  font-family: 'Archivo', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 0.55rem 1rem;
  border: 2px solid #cc2cce;
  color: #f4f1ed;
  background: transparent;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.album-card:hover .album-card__cta {
  background: #cc2cce;
  color: #08080a;
  border-color: #cc2cce;
}
</style>
